import React from 'react';
import { SignUp, Video } from '.';
import css from './bottom.scss';

export function Bottom(props) {
  return (
    <div className={css.flex}>
      <div className={css.column}>
        <Video {...props} />
      </div>
      <div className={css.column}>
        <SignUp {...props} />
      </div>
    </div>
  );
}
